<template>
  <section>
    <header>
      <router-link to="/" class="logo">
        <img src="../assets/i-lead-logo.png">
        <div class="logoText" v-if="1>2">
          <h4 class="loadingLang" v-if="loadingLang">Portal Putusan Penting
            Lingkungan Hidup Indonesia</h4>
          <h4 v-else>{{lang.langs.website_name.value}}</h4>
          <h4 class="ilead">I-LEAD</h4>
          <span>by Indonesian Center for <i class="lb"></i>Environmental Law</span>
          <span class="byIcel">by ICEL</span>
        </div>
      </router-link>
      <div class="menuCnt">
        <div class="loadingMenu" v-if="loadingMenu"></div>
        <div class="theMenu" :class="{open: menuOpen}" v-else>
          <div class="close" v-on:click="menuOpen = false"></div>
          <div class="menuHeaderMobile">
            Menu
          </div>
          <div class="menuItem" v-for="(m, i) in allMenu" :key="i">
            <a class="mi" :href="`/${parentSlug}?ctr=${m.id}`">
              <span v-if="langCode === 'id'">{{m.name}}</span>
              <span v-else-if="langCode === 'en'">{{m.nameEn}}</span>
            </a>
            <div class="submenu" v-if="m.subcategories && m.subcategories.length > 0">
              <li v-for="(m2, i2) in m.subcategories" :key="i2">
                  <a :href="`/${parentSlug}?ctr=${m2.id}`">
                    <span v-if="langCode === 'id'">{{m2.name}}</span>
                    <span v-else-if="langCode === 'en'">{{m2.nameEn}}</span>
                  </a>
                  <div class="nextIcon" v-if="m2.subcategories
                    && m2.subcategories.length > 0"></div>
                  <div class="submenu" v-if="m2.subcategories && m2.subcategories.length > 0">
                    <li><a :href="`/${parentSlug}?ctr=${m3.id}`"
                        v-for="(m3, i3) in m2.subcategories" :key="i3">
                        <span v-if="langCode === 'id'">{{m3.name}}</span>
                        <span v-else-if="langCode === 'en'">{{m3.nameEn}}</span>
                    </a></li>
                  </div>
              </li>
            </div>
          </div>
        </div>
        <div class="btnCnt">
          <button class="langBtn"
            v-on:click.stop="langSelectorOpen = !langSelectorOpen">
            <div class="langIcon" :class="langCode"></div> {{langCode}}
          </button>
          <div class="headerDd" v-if="langSelectorOpen"
            v-on:click.stop="doNothing">
            <li v-on:click="selectLang('id')">
              <div class="langIcon id"></div> Indonesia</li>
            <li v-on:click="selectLang('en')">
              <div class="langIcon en"></div> English</li>
          </div>
        </div>
        <div class="menuToggle" v-on:click.stop="menuOpen = true"></div>
      </div>
    </header>
  </section>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      menuOpen: false,
      langSelectorOpen: false,
      loadingMenu: true,
      allMenu: [],
      parentSlug: '',

      /**
       * Language
       *
       */
      langCode: 'id',
      loadingLang: true,
      lang: null,
    };
  },
  methods: {
    doNothing() {},
    sectionClicked() {
      this.langSelectorOpen = false;
      this.menuOpen = false;
    },
    selectLang(langCode) {
      localStorage.setItem('portal_putusan_penting_icel_lang', langCode);
      window.location.reload();
    },
  },
  mounted() {
    this.langCode = localStorage.getItem('portal_putusan_penting_icel_lang') || 'id';
    // if (!this.langCode) this.langCode = window.navigator.userLanguage || window.navigator.language;
    // if (this.langCode === 'en-US' || this.langCode === 'en') this.langCode = 'en';
    // else if (this.langCode === 'id-ID' || this.langCode === 'id') this.langCode = 'id';
    // else this.langCode = 'en';

    this.$http.get(this.$config.uri(`misc/lang/${this.langCode}`)).then((rlang) => {
      this.loadingLang = false;
      this.lang = rlang.data.data;
      this.$http.get(this.$config.uri('content/parents')).then((r) => {
        if (r.data.status !== 200) return;
        const [parent] = r.data.data;
        this.parentSlug = parent.slug;
        this.$http.get(this.$config.uri('category/all')).then((r2) => {
          this.allMenu = r2.data.status === 200 ? r2.data.data : [];
          /**
           * Deprecated, now use language variable from content
           *
           */
          // eslint-disable-next-line
          // for (const menu of this.allMenu) {
          //   if (menu.name === 'Pidana') menu.name = this.lang.langs.menu_pidana.value;
          //   else if (menu.name === 'Perdata') menu.name = this.lang.langs.menu_perdata.value;
          //   else if (menu.name === 'Administrasi') menu.name =
          // this.lang.langs.menu_administrasi.value;
          //   else if (menu.name === 'Judicial Review') menu.name =
          // this.lang.langs.menu_judicial_review.value;
          // }
          this.loadingMenu = false;
        });
      });
    });
  },
};
</script>

<style scoped lang="scss">
header{
  position: fixed;
  left: 0; right: 0; top: 0;
  z-index: 99;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 80px;
  box-sizing: border-box;
  transition: all .3s ease;
  padding: 0 40px;
  @media (max-width: 1280px) {
    padding: 0 20px;
  }
  @media (max-width: 960px) {
    padding: 0 16px;
  }
  @media (max-width: 680px) {
    height: 60px;
    padding-left: 10px;
    background-color: #fff;
  }
  a{ color: #444; }
  .menuCnt{
    display: flex;
    align-items: center;
    // font-family: 'Inter', sans-serif;
    .loadingMenu{
      width: 400px;
      height: 26px;
      border-radius: 50px;
      background-color: #f5f5f5;
      @media (max-width: 860px) {
        width: 44px; height: 44px;
        position: absolute;
        right: 16px; top: 8px;
        border-radius: 50%;
      }
    }
    .theMenu{
      display: flex;
      position: relative;
      width: 100%;
      .close{
        position: absolute;
        right: 16px; top: 8px;
        width: 44px; height: 44px;
        text-align: center;
        padding-top: 7px;
        box-sizing: border-box;
        display: none;
        z-index: 7;
        background-image: url(../assets/close.png);
        background-size: 16px auto;
        background-position: center;
        background-repeat: no-repeat;
        cursor: pointer;
        @media (max-width: 856px) {
          display: block;
        }
      }
      .menuHeaderMobile{
        height: 60px;
        line-height: 60px;
        font-size: 20px;
        box-sizing: border-box;
        border-bottom: #eee 1px solid;
        padding: 0 30px;
        display: none;
        @media (max-width: 856px) {
          display: block;
        }
      }
      @media (max-width: 856px) {
        display: block;
        position: fixed;
        left: 100%; top: 0; bottom: 0;
        background-color: #fff;
        z-index: 99;
        box-shadow: 0 0 8px rgba(0, 0, 0, .2);
        transition: all .3s ease;
        width: 90%;
        max-width: 380px;
        overflow-y: auto;
        padding-bottom: 120px;
        &.open{
          transform: translateX(-100%);
        }
      }
    }
    .menuItem{
      position: relative;
      &.menuRight{
        margin-left: auto;
      }
      .mi{
        cursor: pointer;
        display: block;
        font-weight: 400;
        font-size: 16px;
        padding: 12px 10px;
        margin: 0 10px;
        opacity: .85;
        transition: all .3s ease;
        color: #444;
        @media (max-width: 856px) {
          font-size: 16px;
          padding: 22px 20px 12px;
          width: 260px;
        }
        &:hover{
          opacity: 1;
          color: #369d66;
        }
        span{
          @media (max-width: 856px) {
            font-weight: 500;
            font-size: 21px;
          }
        }
      }
      .submenu{
        position: absolute;
        right: -20px; top: 98%;
        background-color: #fff;
        padding: 10px 0;
        border-radius: 5px;
        box-shadow: 2px 2px 4px rgba(0, 0, 0, .2);
        display: none;
        min-width: 200px;
        @media (max-width: 856px) {
          position: static;
          display: block;
          box-shadow: none;
          margin: 0 15px;
          background-color: #f5f5f5;
          border-radius: 5px;
          padding: 5px 0;
        }
        &:before{
          content: "";
          position: absolute;
          right: 40px; top: -10px;
          border-left: transparent 10px solid;
          border-right: transparent 10px solid;
          border-bottom: #fff 10px solid;
          z-index: 2;
          @media (max-width: 856px) {
            display: none;
          }
        }
        &:after{
          content: "";
          position: absolute;
          right: 38px; top: -12px;
          border-left: transparent 12px solid;
          border-right: transparent 12px solid;
          border-bottom: #f5f5f5 12px solid;
          z-index: 1;
          @media (max-width: 856px) {
            display: none;
          }
        }
        li{
          list-style: none;
          padding: 0; margin: 0;
          position: relative;
          .nextIcon{
            position: absolute;
            right: 10px; top: 0; bottom: 0;
            width: 12px;
            background-size: 12px auto;
            background-position: center;
            background-repeat: no-repeat;
            background-image: url(../assets/arrow-right-black.png);
            opacity: .4;
            @media (max-width: 856px) {
              display: none;
            }
          }
          a{
            display: block;
            white-space: nowrap;
            border-radius: 0;
            font-size: 15px;
            font-weight: normal;
            padding: 10px 26px;
            @media (max-width: 856px) {
              padding: 6px 15px;
              white-space: normal;
            }
            &:hover{
              background-color: #f5f5f9;
            }
          }
          .submenu{
            display: none;
            top: -10px; right: auto; left: 100%;
            @media (max-width: 856px) {
              display: block;
              background-color: #e5e5e5;
              margin: 4px 10px;
            }
            &:before{
              right: auto; left: -10px; top: 19px;
              border-left: none;
              border-top: transparent 10px solid;
              border-bottom: transparent 10px solid;
              border-right: #fff 10px solid;
            }
            &:after{
              right: auto; left: -12px; top: 17px;
              border-left: none;
              border-top: transparent 12px solid;
              border-bottom: transparent 12px solid;
              border-right: #f5f5f5 12px solid;
            }
          }
          &:hover{
            .submenu{
              display: block;
            }
          }
        }
      }
      &:hover{
        .submenu{
          display: block;
        }
      }
    }
  }
  .menuToggle{
    width: 44px; height: 44px;
    text-align: center;
    margin-left: 10px;
    box-sizing: border-box;
    padding-top: 7px;
    cursor: pointer;
    display: none;
    background-image: url(../assets/menu.png);
    background-size: 24px auto;
    background-position: center;
    background-repeat: no-repeat;
    border-radius: 50%;
    @media (max-width: 856px) {
      display: block;
    }
  }
  .btnCnt{
    position: relative;
    margin-left: 20px;
    padding: 1px 0 0;
    .langBtn{
      background-color: #fff;
      border: #eee 1px solid;
      border-color: transparent;
      display: flex;
      align-items: center;
      padding: 10px 14px;
      color: #444;
      text-transform: uppercase;
      @media (max-width: 680px) {
        padding: 10px 8px;
        margin-left: 10px;
      }
      .langIcon{
        width: 30px; height: 20px;
        margin-right: 10px;
        background-size: contain;
        background-position: center;
        background-repeat: no-repeat;
        &.id{
          background-image: url(../assets/lang/id.svg);
        }
        &.en{
          background-image: url(../assets/lang/gb.svg);
        }
      }
    }
    .headerDd{
      position: absolute;
      right: 0; top: 100%;
      background-color: #fff;
      box-shadow: 2px 2px 6px rgba(0, 0, 0, .2);
      padding: 10px 0;
      border-radius: 5px;
      z-index: 9;
      li{
        list-style: none;
        font-size: 16px;
        padding: 10px 24px;
        padding-left: 68px;
        transition: all .3s ease;
        cursor: pointer;
        position: relative;
        .langIcon{
          width: 30px; height: 20px;
          position: absolute;
          left: 24px; top: 10px;
          &.id{
            background-image: url(../assets/lang/id.svg);
            background-size: contain;
            background-position: center;
            background-repeat: no-repeat;
          }
          &.en{
            background-image: url(../assets/lang/gb.svg);
            background-size: contain;
            background-position: center;
            background-repeat: no-repeat;
          }
        }
        &:hover{
          background-color: #f5f5fe;
        }
        .info{
          white-space: nowrap;
          font-size: 12px;
        }
        &.comingsoon{
          color: #999;
          background-color: #e5e5e5;
          cursor: default;
          .langIcon{
            filter: grayscale(1);
            opacity: .5;
          }
        }
      }
    }
  }
  .logo{
    display: flex;
    text-align: left;
    transition: all .3s ease;
    font-size: 20px;
    color: #444;
    font-weight: 400;
    padding: 0;
    white-space: nowrap;
    align-items: center;
    h4{
      font-weight: 400;
      color: #444;
      margin: 0 0 1px;
      font-size: 20px;
      @media (max-width: 760px) {
        display: none;
      }
      &.loadingLang{
        background-color: #eee;
        color: #eee;
        margin-left: 59px;
        border-radius: 50px;
        @media (max-width: 680px) {
          margin-left: 48px;
        }
      }
      &.ilead{
        display: none;
        @media (max-width: 760px) {
          display: block;
        }
      }
      @media (max-width: 680px) {
        // font-size: 14px;
      }
    }
    span{
      display: block;
      font-size: 14px;
      margin-top: -2px;
      font-weight: 400;
      @media (max-width: 680px) {
        display: none;
      }
      &.byIcel{
        display: none;
        @media (max-width: 680px) {
          display: block;
        }
      }
      i.lb{
        display: none;
        @media (max-width: 680px) {
          display: block;
        }
      }
    }
    img{
      height: 40px;
      margin: -4px 10px 0 0;
      @media (max-width: 680px) {
        height: 36px;
        margin-right: 6px;
      }
    }
  }
}
.scrolled header{
  height: 60px;
  background-color: #fff;
  box-shadow: 0 0 6px rgba(0,0,0,.2);
  @media (max-width: 960px) {
    height: 60px;
  }
}
</style>
